import React, { useContext } from 'react'

import { AstuteContext } from '../context'
import { Card, CardHeading, CardContent } from '../../../../components/layout/Card'
import { Index } from './Index/index'
import { Form } from './Form/index'

export const Views = () => {
  const { state: { view } } = useContext(AstuteContext)

  return (
    <Card className='asute-credentials'>
      <CardHeading>
        <h5>Astute Credentials</h5>
      </CardHeading>
      <CardContent>
        {
          {
            index: () => <Index />,
            form: () => <Form />
          }[view || 'form']()
        }
      </CardContent>
    </Card>
  )
}
